import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Apollo, gql } from 'apollo-angular';

const GET_WAREHOUSE_COVERAGE = gql`
  query GetWarehouseCoverageStatus($filtering: WarehouseCoverageFilteringObject) {
    getWarehouseCoverageStatus(filtering: $filtering) {
      data {
        dashboardData
      }
    }
  }
`;

@Component({
  selector: 'app-coverage-modal',
  templateUrl: './coverage-modal.component.html',
  standalone: false,
  styleUrl: './coverage-modal.component.scss'
})
export class CoverageModalComponent implements OnInit {
  loading = false;
  coverageDetails: any;

  constructor(
    public dialogRef: MatDialogRef<CoverageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { coverage: any, warehouseUniqueId: string },
    private apollo: Apollo
  ) {}

  ngOnInit() {
    if (this.data.warehouseUniqueId) {
      this.fetchCoverageStatus();
    } else {
      this.coverageDetails = this.data.coverage;
    }
  }

  fetchCoverageStatus() {
    this.loading = true;
    this.apollo.query<any>({
      query: GET_WAREHOUSE_COVERAGE,
      variables: { filtering: { warehouseUniqueId: this.data.warehouseUniqueId } },
      fetchPolicy: 'network-only'
    }).subscribe({
     next: (result) => {
  const rawData = result.data?.getWarehouseCoverageStatus?.data?.dashboardData;
  const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
  

  if (parsed?.coverage_ratio) {
    parsed.numeric_ratio = parseFloat(parsed.coverage_ratio.replace('%', ''));
  }

  this.coverageDetails = parsed; 
  this.loading = false;
},
      error: () => {
        this.coverageDetails = this.data.coverage; 
        this.loading = false;
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}